var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Badge } from '../elements/badge';
import { find } from 'lodash';
import { gql, useApolloClient, useMutation } from '@apollo/client';
// import { useFollowableEntities } from '../../hooks/use-followable-entities';
// import { CONVERSATION_CHANNELS_QUERY, useConversationChannels } from '../../hooks/use-conversation-channels';
import { sprintf } from 'sprintf-js';
import { useActivePerson } from '../hooks/use-active-person';
import { useLang } from '../hooks/use-lang';
import { EntityFollowToggle } from './entity-follow-toggle';
import { entityTypeNameFor } from '@shapeable/utils';
import { useEntityTypeDefinitionQuery } from '../hooks/use-entity-type-definition-query';
import { useEntityFollowingState } from '../hooks/use-entity-following-state';
import { EntityStack } from './entity-stack';
import { WaitMessage } from '../elements/wait-message';
export var EntityFollowControlsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    min-height: 20px;\n    flex-direction: row;\n    align-items: center;\n    \n  "], ["\n    display: flex;\n    min-height: 20px;\n    flex-direction: row;\n    align-items: center;\n    \n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UnfollowButtonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n\n    display: none;\n  "], ["\n    ", ";\n\n    display: none;\n  "])), ButtonStyles)
});
var FollowersStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 18px;\n    overflow: visible;\n\n    ", "\n  "], ["\n    height: 18px;\n    overflow: visible;\n\n    ", "\n  "])), function (props) {
    return props.showBorder && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "], ["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "])), theme.UNIT(4, 2), theme.UNIT(4), theme.V_DOT_BG_END());
  })
});
var BadgeStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 16px;\n    line-height: 16px;\n  "], ["\n    height: 16px;\n    line-height: 16px;\n  "])))
});
var FollowersCountStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    white-space: nowrap;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n\n    ", "\n\n  "], ["\n    white-space: nowrap;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n\n    ", "\n\n  "])), function (props) {
    return props.showBorder && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "], ["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "])), theme.UNIT(4, 2), theme.UNIT(4), theme.V_DOT_BG_END());
  })
});
var WaitMessageStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    height: auto;\n  "], ["\n    height: auto;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject([""], [""]))),
  Button: styled(EntityFollowToggle)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  UnfollowButton: styled(EntityFollowToggle)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), UnfollowButtonStyles),
  FollowersCount: styled.h5(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), FollowersCountStyles),
  Followers: styled(EntityStack)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), FollowersStyles),
  WaitMessage: styled(WaitMessage)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles),
  Badge: styled(Badge)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
My.Container = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  ", " {\n    &:hover {\n      ", "\n\n    }\n  }\n"], ["\n  ", " {\n    &:hover {\n      ", "\n\n    }\n  }\n"])), ContainerStyles, function (props) {
  return props.canFollow && props.isFollowing && css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n        ", " {\n          display: none;\n        }\n        ", " {\n          display: flex;\n        }\n      "], ["\n        ", " {\n          display: none;\n        }\n        ", " {\n          display: flex;\n        }\n      "])), My.Badge, My.UnfollowButton);
});
export var EntityFollowControls = function (props) {
  var className = props.className,
    entity = props.entity;
  // const entityTypeDefinition = useEntityDefinition(entity);
  var entityType = entityTypeNameFor(entity);
  var _a = useEntityTypeDefinitionQuery(entityType),
    entityTypeDefinition = _a.entityTypeDefinition,
    loading = _a.loading;
  // Tried sending custom following{PluralLabel} field in useActivePerson, 
  // but there seems to be a caching issue which overrides the queryExtraFields?
  // querying directly for now on ACTIVE_PERSON_QUERY
  var person = useActivePerson().person;
  var t = useLang();
  var client = useApolloClient();
  // const followableEntities = useFollowableEntities();
  var FOLLOW_MUTATION = useMemo(function () {
    return gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      mutation followMutation($entityTypeName: String!, $id: String!) {\n        follow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n        }\n      }\n    "], ["\n      mutation followMutation($entityTypeName: String!, $id: String!) {\n        follow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n        }\n      }\n    "])));
  }, [entity]);
  var UNFOLLOW_MUTATION = useMemo(function () {
    return gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      mutation unfollowMutation($entityTypeName: String!, $id: String!) {\n        unfollow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n        }\n      }\n    "], ["\n      mutation unfollowMutation($entityTypeName: String!, $id: String!) {\n        unfollow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n        }\n      }\n    "])));
  }, [entity]);
  var _b = __read(useMutation(FOLLOW_MUTATION), 1),
    follow = _b[0];
  var _c = __read(useMutation(UNFOLLOW_MUTATION), 1),
    unfollow = _c[0];
  // entities of this type the current user is following
  var followingFieldName = (entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.pluralLabel) ? "following".concat(entityTypeDefinition.pluralLabel) : '';
  var followList = person ? person[followingFieldName] || [] : [];
  var isCurrentlyFollowing = !!find(followList, function (p) {
    return p.id === entity.id;
  });
  var isModerating = !loading && !!find(entity.moderators || [], function (p) {
    return p.id === (person === null || person === void 0 ? void 0 : person.id);
  });
  var _d = __read(useEntityFollowingState(entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.name, entity.id, {
      isFollowing: isCurrentlyFollowing,
      count: entity.followersCount
    }), 2),
    followingState = _d[0],
    setFollowingState = _d[1];
  // Add a useEffect to update followingState when entityTypeDefinition and person change
  React.useEffect(function () {
    if (entityTypeDefinition && person) {
      var followingFieldName_1 = "following".concat(entityTypeDefinition.pluralLabel);
      var followList_1 = person[followingFieldName_1] || [];
      var newFollowing = !!find(followList_1, function (p) {
        return p.id === entity.id;
      });
      setFollowingState({
        isFollowing: newFollowing,
        count: entity.followersCount
      });
    }
  }, [entityTypeDefinition, person]);
  var count = followingState.count,
    isFollowing = followingState.isFollowing;
  var followersLabel = sprintf(count === 1 ? t('%s Follower') : count === 0 ? t("No Followers") : t('%s Followers'), count);
  // const followers = entity.followers || [];
  var onFollow = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // Optimistic update using current state
            setFollowingState({
              isFollowing: true,
              count: followingState.count + 1
            });
            return [4 /*yield*/, follow({
              variables: {
                entityTypeName: entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.name,
                id: entity.id
              }
            })];
          case 1:
            _a.sent();
            client.cache.modify({
              id: client.cache.identify(entity),
              fields: {
                followersCount: function (existing) {
                  if (existing === void 0) {
                    existing = 0;
                  }
                  return existing + 1;
                }
              }
            });
            return [2 /*return*/];
        }
      });
    });
  };
  var onUnfollow = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // Optimistic update using current state
            setFollowingState({
              isFollowing: false,
              count: followingState.count - 1
            });
            return [4 /*yield*/, unfollow({
              variables: {
                entityTypeName: entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.name,
                id: entity.id
              }
            })];
          case 1:
            _a.sent();
            client.cache.modify({
              id: client.cache.identify(entity),
              fields: {
                followersCount: function (existing) {
                  if (existing === void 0) {
                    existing = 0;
                  }
                  return existing - 1;
                }
              }
            });
            return [2 /*return*/];
        }
      });
    });
  };
  var isMe = person && (person === null || person === void 0 ? void 0 : person.id) === entity.id;
  // currently we cannot show the followers of a person as Airtable cannot do a reverse field of a field in the same table.
  // we can create a derived resolver, but this is currently too expensive without a perf tweak.
  var canShowFollowers = (entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.name) !== 'Person';
  if (loading && isMe && !canShowFollowers) {
    return null;
  }
  ;
  return React.createElement(My.Container, {
    canFollow: true,
    isFollowing: isFollowing,
    className: "entity-follow-controls ".concat(className)
  }, loading ? React.createElement(My.WaitMessage, null) : React.createElement(React.Fragment, null, canShowFollowers && React.createElement(My.FollowersCount, {
    showBorder: !isMe
  }, followersLabel), isFollowing ? React.createElement(React.Fragment, null, !isModerating && React.createElement(My.UnfollowButton, {
    isUnfollow: true,
    onClick: onUnfollow,
    entity: entity
  }), React.createElement(My.Badge, null, t(isModerating ? 'Moderating' : 'Following'))) : React.createElement(My.Button, {
    onClick: onFollow,
    entity: entity
  })));
};
EntityFollowControls.defaultProps = EntityFollowControlsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;